import { h, FunctionComponent } from 'preact';
import { TabListContainer } from './Tabs.styles';

export interface TabListProps {
  children?: any;
}

const TabList: FunctionComponent<TabListProps> = ({ children }) => {
  return <TabListContainer>{children}</TabListContainer>;
};

export default TabList;
